
import { Reducer, Effect } from 'umi';
import {getDepartmentList} from '@/services/department'

export interface DepartmentState {
  departmentList:[]
}

export interface DepartmentItem {
    "id": string;
    "createTime"?: string;
    "creator"?: string;
    "modifyTime"?: string;
    "modifier"?: string;
    "name": string 
}

export interface DepartmentModelType {
  namespace: string;
  state: DepartmentState;
  effects: {
    getDepartmentList: Effect;
  };
  reducers: {
    changeDepartmentList: Reducer<DepartmentState>;
  };
}

const Model: DepartmentModelType = {
  namespace: 'department',
  state: {
    departmentList: [],
  },

  effects: {
    *getDepartmentList(_, { call,put }) {
      const response = yield call(getDepartmentList);
      const {list=[]} = response.data;
      if(response.code === 0) { 
          yield put({type:"changeDepartmentList",payload:{departmentList:list}})
      }
      
    }
  },

  reducers: {
    changeDepartmentList(state, { payload }) {
      return {
        ...state,
        departmentList: payload.departmentList
      };
    },
  },
};

export default Model;
